import { Navigate } from "react-router-dom";

function getRole() {
  try {
    const token = localStorage.getItem("token");
    if (!token) return [];
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.roles || [];
  } catch { return []; }
}

export function ProtectedAdmin({ children }) {
  const roles = getRole();

   // Not connected → login
  if (!roles.length) return <Navigate to="/" replace />;

  // Connected but not an admin → wifi-form
  if (!roles.includes("ROLE_ADMIN")) {
    return <Navigate to="/wifi-form" replace />;
  }

  return children;
}

export function ProtectedUser({ children }) {
  const roles = getRole();

  // Not connected → login
  if (!roles.length) return <Navigate to="/" replace />;

  // Admin → redirected to admin
  if (roles.includes("ROLE_ADMIN")) {
    return <Navigate to="/admin" replace />;
  }

  return children;
}